import { computed } from 'vue';
import router from '@/router';

export const useOrgId = (connector: string = '%2F', namespace: string | string[] = '') => {
  const orgId = computed((): string => {
    const routeNamespace = namespace || router.currentRoute.value.params.namespace;
    if (!routeNamespace) return '';
    return routeNamespace as string;
  });
  return { orgId };
};
